import React from 'react';

/** Page hero — matches Checkout & Orders tone */
export function AdminPanelHero({ title, lead, badge, badgeWarn, actions, className = '' }) {
  return (
    <header className={`admin-panel-hero${className ? ` ${className}` : ''}`}>
      <div className="admin-panel-hero__main">
        <h1 className="admin-panel-hero__title">{title}</h1>
        {lead ? <p className="admin-panel-hero__lead">{lead}</p> : null}
      </div>
      {badge ? (
        <span
          className={`admin-panel-hero__badge${badgeWarn ? ' admin-panel-hero__badge--warn' : ''}`}
        >
          {badge}
        </span>
      ) : null}
      {actions ? <div className="admin-panel-hero__actions">{actions}</div> : null}
    </header>
  );
}

/** Section card — shared with checkout (alias in CSS) */
export function AdminPanelSection({ title, subtitle, action, children, className = '' }) {
  return (
    <section className={`admin-panel-section${className ? ` ${className}` : ''}`}>
      <div className="admin-panel-section__head">
        <div>
          <h2 className="admin-panel-section__title">{title}</h2>
          {subtitle ? <p className="admin-panel-section__subtitle">{subtitle}</p> : null}
        </div>
        {action ? <div className="admin-panel-section__action">{action}</div> : null}
      </div>
      <div className="admin-panel-section__body">{children}</div>
    </section>
  );
}

export function AdminPanelStat({ label, value, hint, accent, danger }) {
  return (
    <div
      className={`admin-panel-stat${accent ? ` admin-panel-stat--${accent}` : ''}${
        danger ? ' admin-panel-stat--danger' : ''
      }`}
    >
      <span className="admin-panel-stat__label">{label}</span>
      <span className="admin-panel-stat__value">{value}</span>
      {hint ? <span className="admin-panel-stat__hint">{hint}</span> : null}
    </div>
  );
}

export function AdminPanelStatGrid({ children, className = '' }) {
  return <div className={`admin-panel-stat-grid${className ? ` ${className}` : ''}`}>{children}</div>;
}

export function AdminPanelToolbar({ children, className = '' }) {
  return <div className={`admin-panel-toolbar${className ? ` ${className}` : ''}`}>{children}</div>;
}

export function AdminPanelListCard({ kicker, title, count, actions, children, foot, className = '' }) {
  return (
    <div className={`admin-panel-list-card${className ? ` ${className}` : ''}`}>
      {(kicker || title || actions) && (
        <div className="admin-panel-list-card__head">
          <div>
            {kicker ? <span className="admin-panel-list-card__kicker">{kicker}</span> : null}
            {title ? (
              <div className="admin-panel-list-card__title">
                {title}
                {count != null ? <span className="admin-panel-list-card__count">{count}</span> : null}
              </div>
            ) : null}
          </div>
          {actions ? <div className="admin-panel-list-card__actions">{actions}</div> : null}
        </div>
      )}
      <div className="admin-panel-list-card__body">{children}</div>
      {foot ? <div className="admin-panel-list-card__foot">{foot}</div> : null}
    </div>
  );
}

export function AdminPanelEmpty({ message }) {
  return <p className="admin-panel-empty">{message}</p>;
}

export function AdminPanelAlert({ variant = 'danger', children, className = '' }) {
  const v = variant === 'warning' ? 'warning' : variant === 'info' ? 'info' : variant === 'success' ? 'success' : 'danger';
  return (
    <div className={`admin-panel-alert admin-panel-alert--${v}${className ? ` ${className}` : ''}`} role="alert">
      {children}
    </div>
  );
}

export function AdminPanelTableWrap({ children }) {
  return <div className="admin-panel-table-wrap">{children}</div>;
}

export function AdminPanelRow({ children, className = '' }) {
  return <div className={`admin-panel-row${className ? ` ${className}` : ''}`}>{children}</div>;
}

export function AdminPanelSaveBar({ children, className = '' }) {
  return <div className={`admin-panel-savebar${className ? ` ${className}` : ''}`}>{children}</div>;
}
